var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallNotExist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_941_1750)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28ZM8.16323 7.03099C7.8547 7.03099 7.55879 7.15319 7.34049 7.37076C7.12246 7.5886 7 7.88389 7 8.19177C7 8.49965 7.12246 8.79494 7.34049 9.01278L12.339 14.0008L7.34049 18.9888C7.13458 19.209 7.02241 19.5004 7.02762 19.8015C7.03284 20.1026 7.15503 20.39 7.36843 20.6029C7.58184 20.8159 7.86979 20.9378 8.17155 20.943C8.47331 20.9482 8.7653 20.8363 8.98596 20.6308L13.9845 15.6428L18.983 20.6308C19.1255 20.7832 19.3065 20.8946 19.507 20.9532C19.7074 21.0118 19.92 21.0154 20.1224 20.9638C20.3251 20.9127 20.5103 20.8079 20.6584 20.6605C20.8065 20.5131 20.912 20.3286 20.9638 20.1264C21.0156 19.9242 21.0118 19.7118 20.9528 19.5116C20.8937 19.3114 20.7817 19.1308 20.6285 18.9888L15.6299 14.0008L20.6285 9.01278C20.7812 8.87056 20.8928 8.68996 20.9515 8.48991C21.0102 8.28986 21.0139 8.07773 20.9622 7.87576C20.9109 7.67343 20.8059 7.48866 20.6582 7.3409C20.5105 7.19313 20.3256 7.08786 20.123 7.03616C19.9204 6.98447 19.7076 6.98826 19.5069 7.04715C19.3063 7.10603 19.1253 7.21783 18.983 7.37076L13.9845 12.3588L8.98596 7.37076C8.76766 7.15319 8.47175 7.03099 8.16323 7.03099Z",
    fill: "#535353"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_941_1750"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallNotExist);
export default __webpack_public_path__ + "static/media/small_not_exist.26417fc36f6ef75ee00aa270d899aa3b.svg";
export { ForwardRef as ReactComponent };